import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { getAssetUrl } from '../../../utils/config';
import { Currency } from '../../../utils/countryData';
import { getCarrierI18nKey } from '../../molecules/CarrierOptions';
import FormattedCurrency from '../FormattedCurrency';
import './style.scss';

type DeliverySummaryBadgeProps = {
  deliveries: number;
  quantity: number;
  carrier?: string;
  currency: Currency;
  reduction?: number;
};

const DeliverySummaryBadge = (props: DeliverySummaryBadgeProps) => {
  const { deliveries, quantity, carrier, reduction } = props;

  return (
    <div className="badge">
      <div className="badge__quantity">
        <FormattedMessage id="basket.deliveries" values={{ deliveries }} />
      </div>
      <div className="badge__quantity">
        <FormattedMessage id="basket.quantity" values={{ quantity }} />
      </div>
      {!!reduction && (
        <div className={classNames('badge__quantity', 'badge__quantity--reduced')}>
          <FormattedMessage
            id="basket.reduction"
            values={{
              reduction: <FormattedCurrency value={reduction / 100} />,
            }}
          />
        </div>
      )}
      {carrier && <img src={getAssetUrl(`carriers/${getCarrierI18nKey(carrier)}.svg`)} />}
    </div>
  );
};

export default DeliverySummaryBadge;
